const LIST_USE_STATUS = [
    { id: 1, name: '利用済' },
    { id: 0, name: '未使用' }
];

const initSearchSerialCode = () => {
    return {
        search: {
            serial_code: ''
        },
        filters: {
            is_used: null,
            use_limit: null
        }
    };
};

const initConfigSearchSerialCode = () => {
    return {
        search: {
            serial_code: {
                error: false,
                errorField: 'シリアルコード',
                typesValidate: []
            }
        },
        filters: {
            use_limit: {
                error: false,
                errorField: 'シリアルコード利用制限回数',
                typesValidate: []
            }
        }
    };
};

export { initSearchSerialCode, initConfigSearchSerialCode, LIST_USE_STATUS };
